module.exports = __webpack_public_path__ + "static/img/guidance1.5e6eb83c.png";